import React, { useState } from 'react'

import { useLightMode } from '@/hooks/useLightMode'

import { VStack } from '@chakra-ui/react'

import { DarkProvider, IconButton, InfoIcon, Modal } from '@hivewatch/dark'

import {
  DeviceAssociationDescription,
  DeviceAssociationStatus,
} from '@/components/ui'
import { MODAL_Z_INDEX } from '@/styles/theme'

export const AssociatedDevicesInfoModal = () => {
  const colorScheme = useLightMode()
  const [isOpen, setIsOpen] = useState(false)

  return (
    <>
      <IconButton
        aria-label='Associated devices info'
        borderWidth='0'
        colorScheme={colorScheme}
        dimension={16}
        icon={<InfoIcon />}
        onClick={() => setIsOpen(true)}
      />
      <DarkProvider>
        <Modal
          colorScheme={colorScheme}
          headerStyleOverrides={{
            title: { fontFamily: 'Soehne', fontSize: '24px' },
          }}
          isOpen={isOpen}
          maxW='480px'
          onClose={() => setIsOpen(false)}
          onSave={() => setIsOpen(false)}
          saveButtonLabel='Got it'
          size='compact'
          title='Device Association Status'
          zIndex={MODAL_Z_INDEX}
        >
          <VStack align='stretch' spacing='16px'>
            <DeviceAssociationDescription />
            <DeviceAssociationStatus />
          </VStack>
        </Modal>
      </DarkProvider>
    </>
  )
}
